import { makeStyles } from 'tss-react/mui';
import { alpha } from '@mui/material/styles';
import {
  lightGreen, red, amber, grey
} from '@mui/material/colors';

const categoryWidth = 104;
const listWidth = 188 + 104;

const useStyles = makeStyles()((theme, _params, classes) => ({
  bigSidebar: {
    color: theme?.palette.text.primary,
    padding: 0,
    display: 'flex',
    marginTop: '64px',
    [theme?.breakpoints.up('lg')]: {
      marginTop: theme?.spacing(8),
    },
  },
  category: {
    position: 'absolute',
    zIndex: 9999,
    height: '100%',
    '& .menuIconDiv': {
      display: 'flex',
      width: '32px',
      height: '32px',
    },
    [`& .${classes?.fixedWrap}`]: {

      [`& .${classes?.text}`]: {
        width: '174px',
        maxWidth: '175px',
        height: '46px',
        display: 'none',
      },
      '&:hover': {
        // [`& .${classes?.text}`]: {
        //   width: '174px',
        //   maxWidth: '175px',
        //   height: '46px',
        //   display: 'block'
        // }
      }
    },
  },
  icon: {},
  text: {},
  // lnb 메뉴 스타일
  active: {
    background: '#F6F6FF',
    color: '#7B66FF'
  },
  // opened: {
  //   background: '#F6F6FF',
  //   color: '#7B66FF'
  // },
  selected: {},
  fixedWrap: {
    position: 'fixed',
    overflow: 'auto',
    height: '100%',
    backgroundColor: '#FFF',
    width: 'fit-content',
    borderRight: '1px solid #CDCDD1',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '10px',
    padding: '10px',
    '&:hover': {
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: 'rgba(0,0,0,0.2)',
        border: '1px solid rgba(255,255,255,0.3)',
      }
    }
  },
  avatarHead: {
    textAlign: 'center',
    width: '100%',
    padding: theme?.spacing(0.5),
    marginBottom: theme?.spacing(1),
  },
  statusMenu: {
    '& ul': {
      paddingTop: 0,
    },
    '& li': {
      width: 180
    }
  },
  swipeDrawerPaper: {
    width: categoryWidth + listWidth,
  },
  profile: {
    borderBottom: `1px solid ${theme?.palette.divider}`,
    paddingTop: theme?.spacing(2),
    paddingBottom: theme?.spacing(2),
  },
  name: {
    textAlign: 'left',
    marginLeft: theme?.spacing(1),
    fontSize: 14,
    '& h5': {
      marginBottom: 0
    }
  },
  pinned: {},
  dotStatus: {
    width: theme?.spacing(1.5),
    height: theme?.spacing(1.5),
    display: 'inline-block',
    borderRadius: '50%',
    border: '1px solid #fff',
    marginRight: theme?.spacing(1),
    [`&.${classes?.pinned}`]: {
      position: 'absolute',
      bottom: 3,
      left: 60,
    }
  },
  online: {
    backgroundColor: lightGreen[500]
  },
  bussy: {
    backgroundColor: red[500]
  },
  idle: {
    backgroundColor: amber[500]
  },
  offline: {
    backgroundColor: grey[500]
  },
  menuHead: {
    cursor: 'pointer',
    alignItems: 'baseline',
    display: 'flex',
    flexDirection: 'row',
    width: 'fit-content',
    height: 'fit-content',
    borderRadius: 4,
    '&:hover': {
      background: theme?.palette.action.hover
    },
    // [`&.${classes?.active}`]: {
    //   '&:before': {
    //     content: '""',
    //     position: 'absolute',
    //     width: 5,
    //     height: 68,
    //     borderRadius: 5,
    //     top: 0,
    //     left: theme?.spacing(-1),
    //     background: theme?.palette.primary.dark
    //   },
    //   [`& .${classes?.icon}, .${classes?.text}`]: {
    //     color: theme?.palette.mode === 'dark' ? theme?.palette.primary.main : theme?.palette.primary.main,
    //   },
    // },
    [`& .${classes?.icon}`]: {
      color: alpha(theme?.palette.text.secondary, 0.24),
      display: 'block',
      marginBottom: theme?.spacing(1),
      fontSize: 32,
    },
  },
  item: {},
  listMenu: {
    width: '260px',
    height: 'unset',
    position: 'relative',
    left: '55px',

    '& > ul': {
      padding: '10px',
      width: '200px',
      height: '100%',
      maxHeight: '-webkit-fill-available',
      overflow: 'auto',
      backgroundColor: '#FFF',

      '& > div': {
        width: '100%',
        padding: 'unset',
        marginBottom: 'unset',

        '& > li': {
          cursor: 'pointer',
          padding: 'unset',
        }
      },

      '& > a': {
        width: '100%',
        color: '#787878',
        height: 'fit-content',
        padding: 'unset',
        [`&.${classes?.active}`]: {
          color: '#7B66FF'
        }
      }
    },
    [`& .${classes?.icon}`]: {
      color: alpha(theme?.palette.text.secondary, 0.32),
      fontSize: 14,
    },
    [`& .${classes?.text}`]: {
      paddingLeft: 0,
      paddingRight: 0,
      '& span': {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        display: 'block',
      }
    },
    [`& .${classes?.item}`]: {
      borderRadius: 4,
      textAlign: 'left',
      paddingLeft: 0,
      margin: '4px 0',
      '& > div:first-of-type': {
        margin: `0 ${theme?.spacing(1)}`,
        minWidth: 'auto'
      },
      [`&.${classes?.active}`]: {
        backgroundColor: theme?.palette.mode === 'dark' ? alpha(theme?.palette.secondary.light, 0.24) : alpha(theme?.palette.secondary.light, 0.24),
        [`& .${classes?.icon}`]: {
          color: theme?.palette.mode === 'dark' ? theme?.palette.primary.light : theme?.palette.primary.dark,
        },
        [`& .${classes?.text}`]: {
          '& span': {
            color: theme?.palette.mode === 'dark' ? theme?.palette.primary.light : theme?.palette.primary.dark,
          }
        },
        '&:hover': {
          backgroundColor: theme?.palette.mode === 'dark' ? alpha(theme?.palette.secondary.light, 0.24) : alpha(theme?.palette.secondary.light, 0.24),
        },
        '&:focus': {
          backgroundColor: theme?.palette.mode === 'dark' ? alpha(theme?.palette.secondary.light, 0.24) : alpha(theme?.palette.secondary.light, 0.24),
        }
      }
    }
  },
  drawerPaperClose: {
    width: 0,
    padding: 0,
    overflowX: 'hidden',
    '& ul': {
      position: 'relative'
    }
  },
  nolist: {
    '& nav': {
      height: 'fit-content',
      padding: 'unset'
    },
    // subLnb 스타일
    '& nav a': {
      position: 'relative',
      padding: '1px 8px',
      fontWeight: '700',
      fontSize: '20px',
      lineHeight: '125%',
      display: 'flex',
      alignItems: 'center',
      height: 'fit-content',
      color: '#787878',
      [`&.${classes?.active}`]: {
        color: '#7B66FF'
      }
    },
  },
  title: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: 16,
    lineHeight: '125%',
    display: 'flex',
    alignItems: 'center',
    color: '#141414'
  },
  nested: {
    padding: '0px, 4px !important',
    color: '#141414'
  },
  childMenuWrap: {
    opacity: 0,
    transform: 'translateX(-5px)',
    padding: '10px',
    alignItems: 'flex-start',
    gap: 'unset',
    borderRight: '1px solid #CDCDD1',
  },
  menuLoaded: {
    opacity: 1,
    transform: 'translateX(0px)',
    transition: 'all 0.2s ease-out'
  }
}));

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export default useStyles;
